import { render, staticRenderFns } from "./EmailNormalizedInput.vue?vue&type=template&id=c2b784b0&"
import script from "./EmailNormalizedInput.vue?vue&type=script&lang=ts&"
export * from "./EmailNormalizedInput.vue?vue&type=script&lang=ts&"
import style0 from "./EmailNormalizedInput.vue?vue&type=style&index=0&id=c2b784b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports